<template>
  <div style="overflow-y: auto;overflow-x:hidden;height: 80vh;">
    <el-divider content-position="left"><span style="font-weight: bolder;font-size: large;">物料成本</span></el-divider>
    <el-row class="mb-1" :gutter="5">
      <el-col>
        <el-button type="info" plain @click="refreshData">&nbsp;&nbsp;刷新</el-button>
        <el-button type="info" plain @click="calcPrice" class="ml-2">&nbsp;&nbsp;计算</el-button>
        <el-button type="info" plain @click="saveCostData" class="ml-2"
          :disabled="!editState">&nbsp;&nbsp;保存</el-button>
      </el-col>
    </el-row>
    <el-row class="mb-1" :gutter="5" v-if="UnSelectData.length > 0">
      <el-col>
        <el-tag class="ml-2" effect="dark" type="danger" closable @close="UnSelectData = []"><i
            class="el-icon-star-on"></i>{{
              `红色行为工艺检查不包含数据`
            }}</el-tag>
      </el-col>
    </el-row>
    <div ref="tree_table_div_ref">
      <el-table size="mini" :data="tableData" row-key="id" border default-expand-all
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" @row-click="RowClick"
        :row-class-name="tableRowClassName" highlight-current-row :cell-class-name="tableCellClassName"
        class="tree-table-class w-100" :summary-method="getSummaries" show-summary>
        <el-table-column prop="PartName" label="部件名称" sortable width="300">
        </el-table-column>
        <el-table-column prop="ItemTypeName" label="物料类型" sortable width="100">
        </el-table-column>
        <el-table-column prop="ItemName" label="物料名称" width="180">
        </el-table-column>
        <el-table-column prop="Unit_Use" label="部件用量单位" width="100">
        </el-table-column>
        <el-table-column prop="Total_Qty" label="理论总用量" width="100">
        </el-table-column>
        <el-table-column prop="Calc_Total_Qty" label="计算总用量" width="100">
        </el-table-column>
        <el-table-column prop="Unit_Cost" label="单位成本" width="100">
        </el-table-column>
        <el-table-column prop="Total_Cost" label="成本额" width="150">
        </el-table-column>
        <el-table-column prop="Unit_Price" label="成本单价" width="120" fixed="right">
        </el-table-column>
        <el-table-column prop="Calc_Item_Price" label="单价调整" width="120" fixed="right">
          <template slot-scope="scope">
            <div>
              <el-input-number type="number" v-model.number="scope.row.Calc_Item_Price" :min="0" v-if="scope.row.ItemId"
                :controls="false" class="w-100" @change="checkNum(scope.row)"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Description" label="备注">
        </el-table-column>
      </el-table>
    </div>
    <el-divider content-position="left"><span style="font-weight: bolder;font-size: large;">资源成本</span></el-divider>
    <div ref="tree_table_div_ref">
      <el-table size="mini" :data="resourceTableData" style="width: 100%" row-key="id" border default-expand-all
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" @row-click="RowClick" highlight-current-row>
        <el-table-column prop="ProcessName" label="工序名称" sortable width="350">
        </el-table-column>
        <el-table-column prop="ResourceName" label="资源名称" sortable width="100">
        </el-table-column>
        <el-table-column label="处理数量" sortable width="100" prop="process_qty">
        </el-table-column>
        <el-table-column label="工序损耗" sortable width="100" prop="process_loss_qty">
        </el-table-column>
        <el-table-column label="产出数量" sortable width="100" prop="real_qty">
        </el-table-column>
        <el-table-column prop="ProcessCount" label="工序次数"></el-table-column>
        <el-table-column label="工作时间" prop="work_hours"></el-table-column>
        <el-table-column label="人力成本" prop="human_cost"></el-table-column>
        <el-table-column prop="TimeSetting" label="调机时间"></el-table-column>
        <el-table-column prop="Kilowatt" label="功率"></el-table-column>
        <el-table-column label="电费" prop="electricity"></el-table-column>
        <el-table-column label="工序工时" prop="process_work_hours"></el-table-column>
        <el-table-column prop="Description" label="备注" width="200"></el-table-column>
      </el-table>
    </div>
    <el-divider content-position="left"><span style="font-weight: bolder;font-size: large;">其他成本</span></el-divider>
    <div ref="other_cost_ref">
      <el-row :gutter="20" v-for="(item, index) in other_cost_data" :key="index" class="mb-1" type="flex"
        align="middle">
        <el-col :span="1" style="text-align: end;">{{ index + 1 }}.</el-col>
        <el-col :span="6">
          <el-select placeholder="成本项" size="small" v-model="item.CostId" filterable clearable class="w-100">
            <el-option v-for="_item in cost_option" :key="_item.id" :label="_item.CostName"
              :value="_item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input-number type="number" v-model.number="item.Cost" :min="0" :controls="false" placeholder="费用金额"
            class="w-100"></el-input-number>
        </el-col>
        <el-col :span="6">
          <el-input v-model="item.Description" class="w-100" placeholder="备注"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="info" plain icon="iconfont icon-save" size="mini" @click="saveOtherCost(item)"></el-button>
          <el-button type="danger" plain icon="el-icon-delete" size="mini"
            @click="deleteOtherCost(item, index)"></el-button>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="center">
        <el-button type="info" plain @click="addNewOtherCost" icon="el-icon-plus"></el-button>
      </el-row>
    </div>
    <el-divider content-position="left"><span style="font-weight: bolder;font-size: large;">成本组</span></el-divider>
    <div ref="cost_group_ref" class="w-20">
      <span style="font-size: large;" class="mb-1">{{ SelectItemData.tempItemName
        ? SelectItemData.tempItemName
        : SelectItemData.ItemName }}</span>
      <el-tree :data="cost_tree_data" node-key="id" default-expand-all style="width: 60%">
        <span class="custom-tree-node" slot-scope="{node,data}">
          <span :style="{ 'font-weight': data.cost ? 'light' : 'bold' }">{{ node.label }}</span>
          <span v-if="data.cost" style="text-align: left;width: 30%;">
            单位成本: {{ data.cost }}
          </span>
        </span>;
      </el-tree>
    </div>
  </div>
</template>
<script>
import BaseModal from '../components/modals/baseModal'
import * as TempQuotationCreateItemController from '../../controllers/sd/TempQuotationCreateItemController'
import * as TempQuotationCreateProcessController from '../../controllers/sd/TempQuotationCreateProcessController'
import * as TempQuotationController from '../../controllers/sd/TempQuotationController'
import TempQuotationItem from './TempQuotationItem.vue'
import FileUpload from '../FileUpload.vue'
export default {
  components: { BaseModal, TempQuotationItem, FileUpload },
  props: {
    SelectItemData: { type: Object, default: null },
    currentQuotationDetailId: { type: Number, default: null }
  },
  data() {
    return {
      UnSelectData: [],
      maxTableHeight: 250,
      tableHeight: 200,
      current_item: null,
      tableData: [],
      fields: [],
      all_table_data: [],
      all_table_data2: [],
      process_data: [],
      editState: false,
      resourceTableData: [],
      electricity: 0,
      other_cost_data: [],
      cost_option: [],
      cost_tree_data: []
    }
  },
  async created() { },
  async mounted() {
    this.cost_option = this.$store.state.biz_data.baseData.CostItems
    //查询公司电价
    let dataArea_electricity = _.find(this.$store.state.biz_data.baseData.ElectricityPrices, { dataAreaId: this.SelectItemData.dataAreaId })
    if (dataArea_electricity)
      this.electricity = dataArea_electricity.ElectricityPrices
    // this.tableHeight = '75vh'
    // this.$nextTick(() => {
    //   this.maxTableHeight =
    //     this.$refs.tree_table_div_ref.offsetHeight - 50
    // })
    //查询数据并构造数据
    await this.refreshData()

  },
  methods: {
    //保存其他费用
    async saveOtherCost(item) {
      //数据检查
      if (!item.CostId || !item.Cost) {
        this.msgToasts('保存失败,费用项和费用不能为空', 'error')
        return;
      }
      let data = await TempQuotationController.methods.saveOtherCost(item)
      if (data) {
        this.msgToasts('保存成功', 'success')
      }
      item.id = data[0][0].id
    },
    //删除其他费用
    async deleteOtherCost(item, index) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          if (!item.id) {
            this.other_cost_data.splice(index, 1)
          }
          else {
            let data = await TempQuotationController.methods.deleteOtherCost(item)
            if (data) {
              this.msgToasts('删除成功', 'success')
              this.other_cost_data.splice(index, 1)
            }
          }
        })
        .catch(() => { })
    },
    //新增其他费用
    addNewOtherCost() {
      this.other_cost_data.push({ CostId: null, Cost: 0, Description: '', QuotationId: this.SelectItemData.id })
    },
    //保存数据
    async saveCostData() {
      let edit_data = []
      this.GetEditData(this.tableData[0], edit_data)
      let rt = await TempQuotationCreateItemController.methods.saveData({
        edit: edit_data,
      })
      if (rt) {
        this.msgToasts('修改成功', 'success')
        await this.refreshData()
        this.editState = false;
      } else {
        this.msgToasts('修改失败', 'error')
      }
    },
    //刷新数据
    async refreshData() {
      await this.QueryDataAndConstruction(this.SelectItemData.id)
      await this.QueryDataAndConstruction2(this.SelectItemData.id)
      await this.QueryOtherCostPrice(this.SelectItemData.id)
      await this.groupByCostGroup()

      let p = { is_deleted: { '=': 0 }, QuotationId: { '=': this.SelectItemData.id } }
      let _result = await TempQuotationCreateProcessController.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.process_data = _result[0]
      }
    },
    //计算
    async calcPrice() {
      //检查工序是否齐全
      if (!this.CheckProcess())
        return;
      //计算过程
      //本级用量=上级总用量/本级变化参数*当前配比数/工序良率*(1+工序加放率)+加放基础
      //本级成本额 = 本级用量*成本价(调整后)
      //本级单位成本 = 本级成本额/顶级的总用量
      this.editState = true
      await this.reCalc(this.tableData[0], this.tableData[0])
      await this.QueryDataAndConstruction2(this.SelectItemData.id)
    },
    calcMethod(parent, current) {
      //获取工序良率,加放率,加放基数
      let process_item = _.find(this.process_data, { Quotation_Item_Detail_Id: current.id })
      if (!process_item) return
      let process = _.find(this.process_data, { id: process_item.ParentId })
      if (!process) return
      let resource = _.find(this.$store.state.biz_data.baseData.ProcessResources, { id: process.ProcessResourceId })
      if (!resource) return
      //如果当前为最后一级,则用上一级的计算总用量
      if (current.children && current.children.length > 0) {
        current.Calc_Total_Qty = parent.Calc_Total_Qty / process.RunningParameters * current.Unit_Count / (process.GoodProductRate / 100)
        current.Calc_Total_Qty = current.Calc_Total_Qty * (1 + this.getResourceEnumData(resource, current.Calc_Total_Qty).AddRate / 100) + this.getResourceEnumData(resource, current.Calc_Total_Qty).AddCount
        // console.log(current)
        current.Calc_Total_Qty = this.binaryCalac(current.Calc_Total_Qty, current.ItemTypeId, current.ItemTypeName)
        current.Total_Cost = _.round((current.Calc_Total_Qty * current.Calc_Item_Price), 12)
        current.Unit_Cost = _.round((current.Total_Cost / this.tableData[0].Total_Qty), 12)
      }
      else {
        current.Calc_Total_Qty = parent.Calc_Total_Qty / process.RunningParameters * current.Unit_Count / (process.GoodProductRate / 100)
        current.Calc_Total_Qty = this.binaryCalac(current.Calc_Total_Qty, current.ItemTypeId, current.ItemTypeName)
        current.Total_Cost = _.round((current.Calc_Total_Qty * current.Calc_Item_Price), 12)
        current.Unit_Cost = _.round((current.Total_Cost / this.tableData[0].Total_Qty), 12)
      }
      // console.log(process)
      // current.Calc_Total_Qty = parent.Calc_Total_Qty / process.RunningParameters * current.Unit_Count / (process.GoodProductRate / 100)
      // current.Calc_Total_Qty = current.Calc_Total_Qty * (1 + this.getResourceEnumData(resource, current.Calc_Total_Qty).AddRate / 100) + this.getResourceEnumData(resource, current.Calc_Total_Qty).AddCount
      // // console.log(current)
      // current.Calc_Total_Qty = this.binaryCalac(current.Calc_Total_Qty, current.ItemTypeId, current.ItemTypeName)
      // current.Total_Cost = _.round((current.Calc_Total_Qty * current.Calc_Item_Price), 12)
      // current.Unit_Cost = _.round((current.Total_Cost / this.tableData[0].Total_Qty), 12)
    },
    reCalc(parent_row, current_row) {
      //获取父级上的总用量
      if (current_row.id != 0) {
        //当前级不是顶级,则进行计算
        this.calcMethod(parent_row, current_row)
      }
      if (current_row.children instanceof Array && current_row.children.length > 0) {
        for (var i = 0; i < current_row.children.length; i++) {
          this.reCalc(current_row, current_row.children[i])
        }
      }
    },
    //工艺检查
    async CheckProcess() {
      this.UnSelectData = []
      let p = { is_deleted: { '=': 0 }, QuotationId: { '=': this.SelectItemData.id } }
      let process_result = await TempQuotationCreateProcessController.methods.getData(p)
      let item_result = await TempQuotationCreateItemController.methods.getData(p)
      if (!_.isNull(process_result) && process_result && process_result.length > 0 && !_.isNull(item_result) && item_result && item_result.length > 0) {
        //数据构造
        process_result = process_result[0]
        this.process_data = process_result
        item_result = item_result[0]
        //进行对比
        this.CompareItem(item_result, process_result)
      } else {
        this.msgToasts('未查询到工序或物料数据,无法进行对比!', 'error')
        return false
      }
    },
    CompareItem(item_result, process_result) {
      let p_item = _.filter(process_result, function (o) { return o.ItemId })
      let i_item = _.filter(item_result, function (o) { return o.ItemId })
      let diff = []
      for (var i = 0; i < i_item.length; i++) {
        let _index = _.findIndex(p_item, function (j) {
          return j.ItemId === i_item[i].ItemId
        })
        if (_index < 0) {
          diff.push(i_item[i])
        }
      }
      if (diff.length > 0) {
        this.UnSelectData = diff
        return false
      }
      else {
        return true
      }
    },
    //进制法计算
    binaryCalac(num, itemType, ItemTypeName) {
      let type = '';
      if (!itemType && ItemTypeName != '部件')
        return Math.floor(num * 1000000) / 1000000//(默认6位小数 且无四舍五入计算)
      type = _.find(this.$store.state.biz_data.baseData.ItemType, { id: itemType })
      //没有itemTypeId的 就去找物料
      if (!itemType) {
        type = _.find(this.$store.state.biz_data.baseData.ItemType, { itemTypeName: ItemTypeName })
      }
      if (type) {
        if (type.BinaryType === 0) {
          //无进制法(默认6位小数,且无四舍五入计算)
          return Math.floor(num * 1000000) / 1000000
        }
        else if (type.BinaryType === 1) {
          //四舍五入(保留6位小数)
          return _.round(num, 12)
        }
        else {
          //进一法
          return Math.ceil(num)
        }
      }
      else
        return num
    },
    //构造第一行数据
    AddFirstLineData() {
      this.tableData = []
      this.tableData.push({
        id: -1,
        PartName: this.SelectItemData.tempItemName
          ? this.SelectItemData.tempItemName
          : this.SelectItemData.ItemName,
        Total_Qty: this.SelectItemData.quotationQty,
        Calc_Total_Qty: this.SelectItemData.quotationQty,
      })
    },
    //查询并构造树形数据
    async QueryDataAndConstruction(quotationId) {
      this.AddFirstLineData()
      let p = { QuotationId: quotationId }
      let _result = await TempQuotationCreateItemController.methods.getTempQuotaionPriceList(p)
      // console.log(_result)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _result[0].forEach(o => {
          if (o.ParentId == 0) {
            o.ParentId = -1
          }
        });
        //数据构造
        this.all_table_data = _result[0]
        this.all_table_data.push(this.tableData[0])
        this.makeTableData(_result[0], this.tableData)
      }
    },
    //树状数据构造
    makeTableData(all_data, data) {
      for (let i = 0; i < data.length; i++) {
        let children = _.filter(all_data, { ParentId: data[i].id })
        if (children) {
          data[i].Calc_Item_Price = !data[i].Calc_Item_Price ? data[i].Unit_Price : data[i].Calc_Item_Price
          this.$set(data[i], 'children', children)
          this.makeTableData(all_data, data[i].children)
        }
      }
    },
    // 行点击事件
    RowClick(row) {
      this.current_item = row
    },
    //单元格样式修改
    tableCellClassName({ row, column }) {
      if (row.Unit_Price != row.Calc_Item_Price && (column.property == 'Calc_Item_Price' || column.property == 'Unit_Price')) {
        return 'diff-total-qty-row'
      }
      else
        return ''
    },
    //行样式修改
    tableRowClassName({ row }) {
      if (!row.ItemTypeId) {
        return 'bujian-row'
      } else if (
        _.findIndex(this.UnSelectData, { id: row.id }) > -1
      ) {
        return 'error-row'
      } else return ''
    },
    //根据数量 获取工序资源的枚举值
    getResourceEnumData(resource, qty) {
      if (qty >= 1 && qty <= 1000) {
        return { AddCount: resource.AddCount_1To1K, AddRate: resource.AddRate_1To1K }
      }
      if (qty >= 1001 && qty <= 2000) {
        return { AddCount: resource.AddCount_1001To2K, AddRate: resource.AddRate_1001To2K }
      }
      if (qty >= 2001 && qty <= 3000) {
        return { AddCount: resource.AddCount_2001To3K, AddRate: resource.AddRate_2001To3K }
      }
      if (qty >= 3001 && qty <= 5000) {
        return { AddCount: resource.AddCount_3001To5K, AddRate: resource.AddRate_3001To5K }
      }
      if (qty >= 5001 && qty <= 10000) {
        return { AddCount: resource.AddCount_5001To10K, AddRate: resource.AddRate_5001To10K }
      }
      if (qty >= 10001 && qty <= 20000) {
        return { AddCount: resource.AddCount_10001To20K, AddRate: resource.AddRate_10001To20K }
      }
      if (qty >= 20001 && qty <= 40000) {
        return { AddCount: resource.AddCount_20001To40K, AddRate: resource.AddRate_20001To40K }
      }
      if (qty >= 40001) {
        return { AddCount: resource.AddCount_40001ToMax, AddRate: resource.AddRate_40001ToMax }
      }
    },
    //输入验证修改
    checkNum(row) {
      if (!row.Calc_Item_Price || row.Calc_Item_Price == undefined || typeof row.Calc_Item_Price != 'number') {
        row.Calc_Item_Price = 0
      }
    },
    GetEditData(row, edit_data) {
      let p = _.cloneDeep(row)
      if (p.id != 0) edit_data.push({ id: p.id, Calc_Total_Qty: p.Calc_Total_Qty, Unit_Cost: p.Unit_Cost, Calc_Item_Price: p.Calc_Item_Price, Total_Cost: p.Total_Cost })
      if (row.children instanceof Array && row.children.length > 0) {
        for (var i = 0; i < row.children.length; i++) {
          this.GetEditData(row.children[i], edit_data)
        }
      }
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.property === 'Total_Cost') {
          sums[index] = _.sumBy(this.all_table_data, "Total_Cost")
          sums[index] += ' 元';
        }
      });
      return sums;
    },
    async QueryOtherCostPrice(quotationId) {
      let p = { is_deleted: { '=': 0 }, QuotationId: { '=': quotationId } }
      let _result = await TempQuotationController.methods.getOtherCost(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        //数据构造
        _result[0] = _.orderBy(_result[0], ["SortNo"], ["asc"])
        // console.log(_result[0])
        this.other_cost_data = _result[0]
      }
    },
    async groupByCostGroup() {
      this.cost_tree_data = []
      let _data = JSON.parse(JSON.stringify(this.all_table_data))
      _data = _.filter(_data, function (o) { return o.ItemId })
      let dataList = _.groupBy(_data, "CostGroupId")
      //物料成本
      Object.keys(dataList).forEach(key => {
        if (key != 'undefined') {

          let c = _.map(dataList[key], (v) => {
            return {
              id: v.id,
              label: v.ItemName,
              cost: _.round((v.Calc_Item_Price / this.SelectItemData.quotationQty), 12)
            }
          });
          this.cost_tree_data.push({ id: key, label: key == 'null' ? '暂无分组' : key, children: c })
        }
      });
      //电费
      let new_data = [];
      this.getElectricityAndPersonCost(this.resourceTableData, new_data, '')
      if (new_data.length > 0) {
        let c = _.map(new_data, (v) => {
          return {
            id: v.id,
            label: v.label,
            cost: _.round((v.cost / this.SelectItemData.quotationQty), 12)
          }
        });
        this.cost_tree_data.push({ id: 'O23电费', label: 'O23电费', children: c })
      }
      //其他成本
      if (this.other_cost_data.length > 0) {
        let c = _.map(this.other_cost_data, (v) => {
          return {
            id: v.id,
            label: _.find(this.cost_option, function (o) { return o.id == v.CostId }).CostName,
            cost: _.round((v.Cost / this.SelectItemData.quotationQty), 12)
          }
        });
        this.cost_tree_data.push({ id: 'other_cost', label: '其他费用', children: c })
      }
    },
    getElectricityAndPersonCost(data, new_data, process_name) {
      if (data.length > 0) {
        data.forEach(o => {
          if (o.electricity) {
            new_data.push({ id: 'electricity' + o.id, label: process_name + '//' + o.ProcessName, cost: o.electricity })
          }
          if (o.children && o.children.length > 0) {
            this.getElectricityAndPersonCost(o.children, new_data, o.ProcessName)
          }
        });
      }
    },
    async QueryDataAndConstruction2(quotationId) {
      this.AddFirstLineData2()
      let p = { is_deleted: { '=': 0 }, QuotationId: { '=': quotationId } }
      let _result = await TempQuotationCreateProcessController.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        //数据构造
        _result[0] = _.orderBy(_result[0], ["SortNo"], ["asc"])
        this.all_table_data2 = _result[0]
        this.all_table_data2.push(this.tableData[0])
        this.makeTableData2(_result[0], this.resourceTableData)
      }
    },
    //树状数据构造
    makeTableData2(all_data, data) {
      data = _.orderBy(data, ["SortNo"], ["asc"])
      for (let i = 0; i < data.length; i++) {
        //计算处理数量 工序损耗 产出数量 工作时间 人力成本(暂时无法计算) 电费
        if (!data[i].Quotation_Item_Detail_Id && data[i].id != 0)
          this.calcProcessData(data[i])
        let children = _.filter(all_data, { ParentId: data[i].id })
        if (children) {
          this.$set(data[i], 'children', children)
          this.makeTableData2(all_data, data[i].children)
        }
      }
    },
    //工序数据 计算处理数量 工序损耗 产出数量 工作时间 人力成本(暂时无法计算) 电费
    calcProcessData(process) {
      //获取到工序对应的物料的计算用量
      let parent = _.find(this.all_table_data2, { id: process.ParentId })
      let item = null
      if (process.ParentId == 0) {
        item = this.tableData[0]
      }
      else
        item = _.find(this.all_table_data, { id: parent.Quotation_Item_Detail_Id })
      if (!item.Calc_Total_Qty)
        return
      let resource = _.find(this.$store.state.biz_data.baseData.ProcessResources, { id: process.ProcessResourceId })
      //处理数量 = 计算用量
      process.process_qty = item.Calc_Total_Qty / (process.GoodProductRate / 100)
      process.process_qty = process.process_qty * (1 + this.getResourceEnumData(resource, process.process_qty).AddRate / 100) + this.getResourceEnumData(resource, process.process_qty).AddCount
      // console.log(item)
      process.process_qty = this.binaryCalac(process.process_qty, item.ItemTypeId, item.ItemTypeName)
      //工序损耗 = 处理数量 - 计算用量
      process.process_loss_qty = Math.floor((process.process_qty - item.Calc_Total_Qty) * 1000000) / 1000000;
      //产出数量 = 计算用量
      process.real_qty = item.Calc_Total_Qty
      //工作时间 = (处理数量/产能+设置时间)*工序次数
      process.work_hours = (process.process_qty / process.ProductionCapacity + process.TimeSetting) * process.ProcessCount
      process.work_hours = Math.floor(process.work_hours * 1000000) / 1000000;
      //工序工时 = 工作时间*标准人力
      process.process_work_hours = process.work_hours * process.StandardManpower
      process.process_work_hours = Math.floor(process.process_work_hours * 1000000) / 1000000;
      //电费 = 工作时间*功率/1000*公司电价
      process.electricity = process.work_hours * process.Kilowatt / 1000 * this.electricity
      process.electricity = Math.floor(process.electricity * 1000000) / 1000000;
    },
    AddFirstLineData2() {
      this.resourceTableData = []
      this.resourceTableData.push({
        id: 0,
        ProcessName: this.SelectItemData.tempItemName
          ? this.SelectItemData.tempItemName
          : this.SelectItemData.ItemName,
      })
    },
  }
}
</script>
<style>
.hb_table_quotationorder_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 195rem;
}

.el-table .bujian-row {
  background: #e1f3d8;
}

.el-table .error-row {
  background: #F56C6C;
}

.tree-table-class .el-table__row {
  height: 30px;
  padding: 0;
}

.tree-table-class .el-table__cell {
  white-space: normal;
  padding: 0;
}

.el-table .diff-total-qty-row {
  background: #E6A23C;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
